import styled from 'styled-components';

export const ReportBugButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;
